import { Injectable, inject } from '@angular/core';
import { AwareHttpService, IAwareCollection } from '@appbolaget/aware-http';
import { Client, Contract, ContractSignature } from '@appbolaget/aware-model';
import { Observable } from 'rxjs';

export interface ISaveContractValues {
    uuid?: string;
    alias?: string;
    title: string;
    content: string;
    key?: string;
    type?: string;
    publish_at?: string;
    unit: string;
    child?: string;
}

@Injectable({ providedIn: 'root' })
export class ContractService {
    private api = inject(AwareHttpService);
    //#awareContractService = inject(AwareContractService);

    initAwareContractService() {
        // this.#awareContractService.unsignedContracts$.subscribe({
        //     next: (contracts) => {
        //         console.log('Unsigned contracts:', contracts);
        //     },
        // });
    }

    getContractById(uuid: string): Observable<Contract> {
        return this.api.show<Contract>('contracts', uuid).toModel(Contract).header('published', '*').header('expired', '*').execute();
    }

    getContractByIdWithRevisions(uuid: string): Observable<Contract> {
        return this.api
            .show<Contract>('contracts', uuid)
            .stream('up')
            .toModel(Contract)
            .with('children^*')
            .header('published', '*')
            .header('expired', '*')
            .execute();
    }

    getContractSignatures(uuid: string, page: number = 1): Observable<IAwareCollection<ContractSignature>> {
        return this.api
            .get<IAwareCollection<ContractSignature>>(`contracts/${uuid}/signatures`)
            .with('client', 'proxy')
            .page(page)
            .stream('up')
            .toCollection(ContractSignature)
            .header('published', '*')
            .header('expired', '*')
            .execute();
    }

    getContractSignees(uuid: string): Observable<IAwareCollection<Client>> {
        return this.api
            .get<IAwareCollection<Client>>(`contracts/${uuid}/clients`)
            .toCollection(Client)
            .header('published', '*')
            .header('expired', '*')
            .execute();
    }

    save(values: ISaveContractValues): Observable<Contract> {
        const { uuid, ...data } = values;
        const url = uuid ? `contracts/${uuid}` : 'contracts';
        const method = uuid ? 'put' : 'post';

        data.key = data.key ?? '';
        return this.api[method]<Contract>(url, data).toModel(Contract).header('published', '*').header('expired', '*').execute();
    }

    saveRevision(values: ISaveContractValues): Observable<Contract> {
        const { uuid, ...data } = values;
        data.child = uuid;

        return this.api.post<Contract>('contracts', data).header('published', '*').header('expired', '*').toModel(Contract).execute();
    }

    remove(uuid: string): Observable<void> {
        return this.api.delete<void>('contracts', null, uuid).header('published', '*').header('expired', '*').execute();
    }
}
